import React from 'react';

function UnLinkIcon() {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='24'
			height='24'
			fill='none'
			viewBox='0 0 24 24'
		>
			<path
				stroke='#141414'
				strokeLinecap='round'
				strokeWidth='1.5'
				d='M16.846 14.61l2.61-2.61A5.272 5.272 0 1012 4.544l-2.61 2.61m5.22 9.692L12 19.456A5.272 5.272 0 114.544 12l2.61-2.61'
			></path>
			<path
				stroke='#141414'
				strokeLinecap='round'
				strokeLinejoin='round'
				strokeWidth='1.5'
				d='M22 17h-2.079M17 22v-2.079M2 7h2.079M7 2v2.079'
			></path>
		</svg>
	);
}

export default UnLinkIcon;
